var _path, _g, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound55BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  fill: "none",
  viewBox: "0 0 60 57",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M30 19c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-figma-trr": "r5u2.5-0f"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M24.793 4.274A2.5 2.5 0 0 1 27.283 2h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.727h-6.525a2.5 2.5 0 0 1-2.49-2.727l.546-6Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M26.737 3c-.686 0-1.314.388-1.621 1.002l-.223.446a1 1 0 0 1-1.789-.895l.223-.445A3.812 3.812 0 0 1 26.737 1h6.524c1.444 0 2.764.816 3.41 2.108l.222.445a1 1 0 0 1-1.789.895l-.222-.446A1.812 1.812 0 0 0 33.26 3h-6.524Z",
  clipRule: "evenodd"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Round-5-5-B-Error_svg__Repeat%20group%201_inner",
  transform: "rotate(72 30 30)"
})), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Round-5-5-B-Error_svg__Repeat%20group%201_inner",
  transform: "rotate(144 30 30)"
})), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Round-5-5-B-Error_svg__Repeat%20group%201_inner",
  transform: "rotate(-144 30 30)"
})), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Round-5-5-B-Error_svg__Repeat%20group%201_inner",
  transform: "rotate(-72 30 30)"
})));
SvgRound55BError.viewBox = '0 0 60 57';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound55BError);
export default ForwardRef;